import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/eye-open.svg';
import { Icon } from '../Icon/Icon';
export const EyeOpenIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
